import { AddVendedorForm } from "../../../vendedores/AddVendedorForm/components/AddVendedorForm";
import { VendedorInfo } from "src/types/vendedor";
import { Dispatch, SetStateAction, useState } from "react";
import { useAddVendedoresMutation } from "../../../../api/visitasApi";
import { ErrorMessage } from "../../../../components/errors/ErrorMessage";
import { getErrorMessage } from "../../../../utils/errorHelpers";
import { ActionButtons } from "src/components/ui/ActionButtons";

interface Props {
    setVendedoresAgregados: Dispatch<SetStateAction<VendedorInfo[]>>;
    setIsAddVendedores: Dispatch<SetStateAction<boolean>>;
    vendedoresAgregados: VendedorInfo[];
    visitaId: number;
}

export function AddVendedoresToVisita({ visitaId, vendedoresAgregados, setVendedoresAgregados, setIsAddVendedores }: Props) {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [addVendedores, { isLoading, isError }] = useAddVendedoresMutation();

    const onSaveVendedores = async () => {
        try {
            const vendedores = vendedoresAgregados.map((vendedor) => vendedor.vendedorId);
            await addVendedores({ visitaId, vendedores }).unwrap();
            setIsAddVendedores(false);
            setVendedoresAgregados([]);
        } catch (error) {
            setErrorMessage(getErrorMessage(error));
        }
    }

    return (
        <div className="flex flex-col h-full overflow-hidden bg-gray-100 rounded-md p-2 border border-gray-600">

            <AddVendedorForm
                setVendedoresAgregados={setVendedoresAgregados}
                vendedoresAgregados={vendedoresAgregados}
                dealId={visitaId} />
            
            {isError && (
                <ErrorMessage>
                    {errorMessage}
                </ErrorMessage>
            )}

            <ActionButtons 
                isLoading={isLoading}
                saveButtonText="Confirmar vendedores"
                saveButtonType="button"
                onSave={onSaveVendedores}
                onCancel={() => setIsAddVendedores(false)}/>
        </div>
    );
}
